import { render, staticRenderFns } from "./afiliacion-sistema-riesgos.vue?vue&type=template&id=29d93d3b&scoped=true&"
import script from "./afiliacion-sistema-riesgos.vue?vue&type=script&lang=js&"
export * from "./afiliacion-sistema-riesgos.vue?vue&type=script&lang=js&"
import style0 from "./afiliacion-sistema-riesgos.vue?vue&type=style&index=0&id=29d93d3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d93d3b",
  null
  
)

export default component.exports